import { AppEventDispatcher } from './../../utils/AppEventDispatcher';
import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { EventTypes } from '../EventTypes';
import { TransfersOtherBanksEventType } from '../../master/transfers-other-banks/transfers-other-banks.event.type';
import { TweenMax, Quint } from 'gsap';
import { SharedService } from '../shared.service';
import { ModalErrorEventType } from './modal-error.event.type';

@Component({
	selector: 'app-modal-error',
	templateUrl: './modal-error.component.html',
	styleUrls: ['./modal-error.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class ModalErrorComponent implements OnInit, OnDestroy {

	title: string;
	text: string;
	acceptHandler: any;
	acceptHandlerData: any;
	loading = false;
	access: any;
	cancelButton: string;
	acceptButton: string;
	hasCancelButton = true;

	constructor(private sharedService: SharedService ) { }

	ngOnInit() {
		AppEventDispatcher.listen( EventTypes.MODAL_ERROR.MODAL_ERROR, data => {
			if(!data || !data.text || !data.title){
				return;
			}

			this.title = data.title;
			this.text = data.text;
			this.cancelButton = data.cancelButton ? data.cancelButton : 'Não',
			this.acceptButton = data.acceptButton ? data.acceptButton : 'Sim',
			this.hasCancelButton = data.hasCancelButton !== undefined? data.hasCancelButton : true,
			this.acceptHandler = data.acceptHandler;
			this.acceptHandlerData = data.acceptHandlerData;
			this.access = data.access;

			this.show();
		});

		AppEventDispatcher.listen(EventTypes.MODAL_ERROR.MODAL_CLOSE, data => {
			this.hide();
		});
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(EventTypes.MODAL_WARNING.MODAL_CLOSE);
		AppEventDispatcher.removeListener(EventTypes.MODAL_ERROR.MODAL_ERROR);
	}

	show() {
		$('[data-component="modal-error"]').show();
		TweenMax.to('[data-component="modal-error"] .modal', 1, {top: '50%', ease: Quint.easeOut});
	}

	hide() {
		TweenMax.to('[data-component="modal-error"] .modal', .6, {top: '-150%', ease: Quint.easeIn, onComplete: () => {
			$('[data-component="modal-error"]').hide();
			$('[data-component="modal-error"]').appendTo('app-modal-error');
		}});
	}

	accept() {
		this.hide();
		AppEventDispatcher.dispatch(ModalErrorEventType.MODAL.OK, { title: this.title, text: this.text });
		AppEventDispatcher.dispatch(ModalErrorEventType.MODAL.TRUE_MODAL, { data: false });
	}

	cancel() {
		AppEventDispatcher.dispatch(ModalErrorEventType.MODAL.CANCEL, { title: this.title, text: this.text });
		this.hide();
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/shared/modal-error/modal-error.component.ts